import pro3 from "../assets/Mathspartner.png"
import pro2 from "../assets/Pets wallah.png"
import pro1 from "../assets/Helping Hand.png"
import pro4 from "../assets/TO-DO List.png"
import pro5 from "../assets/Drum kit.png"

const ProjectCardData =[
    {
        imgsrc: pro1,
        title: "Helping Hand Website",
        text: "Helping Hand is a unique website that offers a wide range of essential home services to customers. Whether you need a plumber, electrician, salon, spa, or event management services, Helping Hand has got you covered", 
        view: "https://helping-hand-one.vercel.app/"
    },
       {
        imgsrc: pro2,
        title: "PET'S WALLAH Website",
        text: " I created this website to provide pet daycare services and premium pet food Sellers. user can book an appointment with us and also order his pet food.", 
        view: "https://silly-begonia-d117f3.netlify.app/"
    },
       {
        imgsrc: pro3,
        title: "Maths Partner Website",
        text: "A web app for solving math problems with features like problem input field, category buttons, search button, history button, search page button, and delete button.", 
        view: "https://stellular-bublanina-ad9215.netlify.app/"
    },
     {
        imgsrc: pro4,
        title: "Plan Your Day!",
        text: " User can plan his task according to task Priority. Website is complete responsive", 
        view: "https://subtle-brigadeiros-6b8391.netlify.app/"
    },

 {
        imgsrc: pro5,
        title: "Instrumental Sound Website",
        text: "Instrumental Sound website is an interactive platform that allows users to play and hear different instrument sounds by pressing keyboard keys. ", 
        view: "https://astonishing-kringle-7ce317.netlify.app/"
    },


];

export default ProjectCardData;